import axios from '@/libs/api.request'

/**
 * 获取会员列表
 * @returns {wx.RequestTask | never}
 */
export const getMemberList = (params) => {
  return axios.request({
    url: 'main/member/getList',
    method: 'get',
    params: params
  })
}
/**
 * 获取会员详细信息
 * @returns {wx.RequestTask | never}
 */
export const getMemberDetail = (params) => {
  return axios.request({
    url: 'main/member/getDetail',
    method: 'get',
    params: params
  })
}
/**
 * 删除会员
 * @returns {wx.RequestTask | never}
 */
export const deleteMember = (data) => {
  return axios.request({
    url: 'main/member/del',
    method: 'post',
    params: data
  })
}

/**
 * 获取用户协议
 * @returns {wx.RequestTask | never}
 */
export const getMemberProtocol = (params) => {
  return axios.request({
    url: 'main/member/getProtocol',
    method: 'get',
    params
  })
}
/**
 * 更新用户协议
 * @returns {wx.RequestTask | never}
 */
export const saveMemberProtocol = (data) => {
  return axios.request({
    url: 'main/member/saveProtocol',
    method: 'post',
    data
  })
}
/**
 * 获取用户反馈列表
 * @returns {wx.RequestTask | never}
 */
export const getFeedbackList = (params) => {
  return axios.request({
    url: 'main/member/getFeedbackList',
    method: 'get',
    params
  })
}

/**
 * 获取会员等级列表
 * @param params
 * @returns {AxiosPromise}
 */
export const getLevelList = (params) => {
  return axios.request({
    url: 'main/member/getLevelList',
    method: 'get',
    params
  })
}

/**
 * 更新会员等级
 * @param params
 * @returns {AxiosPromise}
 */
export const saveLevel = (data) => {
  return axios.request({
    url: 'main/member/saveLevel',
    method: 'post',
    data
  })
}
